import { Credentials } from "./common/credentials.js";
import { ServerContext } from "./types/server.js";

export class InvalidRemoteSingleStyleguideContextError extends Error {
  constructor() {
    super(
      "Single-styleguide remote MCP requires JWT credentials with styleguideId",
    );
    this.name = "InvalidRemoteSingleStyleguideContextError";
  }
}

function getFeatureOverrides(): Record<string, boolean> {
  const overrides = process.env["FEATURE_OVERRIDES"];
  if (!overrides) return {};

  return Object.fromEntries(
    overrides
      .split(",")
      .map((name) => name.trim())
      .filter(Boolean)
      .map((name) => [name, true]),
  );
}

export function createLocalServerContext(): ServerContext {
  return {
    connectionMode: "local",
    features: getFeatureOverrides(),
  };
}

export function createRemoteOauthServerContext(
  features: Record<string, boolean> = {},
): ServerContext {
  return {
    connectionMode: "remote_oauth",
    features: { ...features, ...getFeatureOverrides() },
  };
}

export function createRemoteSingleStyleguideServerContext(
  credentials: Credentials,
): ServerContext {
  if (
    credentials.type !== "jwt" ||
    typeof credentials.styleguideId !== "number"
  ) {
    throw new InvalidRemoteSingleStyleguideContextError();
  }

  return {
    connectionMode: "remote_single_styleguide",
    features: { ...credentials.features, ...getFeatureOverrides() },
    styleguideId: credentials.styleguideId,
    styleguideName: credentials.styleguideName,
    tokenSets: credentials.tokenSets,
  };
}
